import sysend from 'sysend';

import { APP_INIT, configUpdateAction } from 'common/actions/config';
import {
  FIRST_VISIT_FROM_LS_KEY,
  WAS_COOKIES_POLICY_ACCEPTED_LS_KEY,
} from 'common/constants/config';
import { LocalStorage } from 'common/helpers/Storage';
import { LOGIN_PATH } from 'common/selectors/sidebar/common';
import { formatUrl } from 'common/helpers/routesAccess';
import { getQueryParamsFromUrl } from 'common/helpers/Url';

const updateFirstVisitFrom = (dispatch) => {
  let firstVisitFrom = LocalStorage.get(FIRST_VISIT_FROM_LS_KEY);

  if (!firstVisitFrom) {
    firstVisitFrom = document.referrer;
    LocalStorage.set(FIRST_VISIT_FROM_LS_KEY, firstVisitFrom);
  }
  dispatch(configUpdateAction({ firstVisitFrom }));
};

const updateCookiesPolicyAccepted = (dispatch) => {
  const wasCookiesPolicyAccepted = Boolean(
    LocalStorage.get(WAS_COOKIES_POLICY_ACCEPTED_LS_KEY),
  );

  dispatch(configUpdateAction({ wasCookiesPolicyAccepted }));
};

const updateReferrer = (dispatch) => {
  const { referrer } = document;

  dispatch(configUpdateAction({ referrer }));
};

/**
 * Config middleware function
 */
const middleware = (store) => (next) => (action) => {
  const { dispatch } = store;

  const result = next(action);

  switch (action.type) {
    case APP_INIT: {
      updateFirstVisitFrom(dispatch);
      updateCookiesPolicyAccepted(dispatch);
      updateReferrer(dispatch);
      sysend.on('userIdCheck', ({ id }: { id: number }) => {
        const { id: currentId } = store.getState().config?.user || {};

        if (currentId !== id) {
          const { pathname, href } = window.location;
          const url = currentId
            ? formatUrl({
                pathname: LOGIN_PATH,
                query: { redirectTo: pathname },
              })
            : getQueryParamsFromUrl(href).redirectTo;

          if (url) {
            window.location.replace(url as string);
          } else {
            window.location.reload();
          }
        }
      });
      break;
    }
    default:
      break;
  }

  return result;
};

export default middleware;
